<template>
    <div class="container" v-loading="tableing">
        <div class="header">
            请选择你要考级的机构
            <el-button type="primary" @click.native="clickRecord" plain size="mini" class="record">测评记录</el-button>
            <el-button class="exit" size="mini" @click="logOut()"> 注 销 </el-button>
        </div>
        <div class="main">
            <div class="orgList" v-for="(item,index) in list" :key="index" @click="comeList(item.id)">
                <div class="orgList-imgBox">
                    <img class="orgList-img" :src="item.orgAppLogo" alt="" srcset="">
                </div>
                <span class="orgList-name">{{item.name}} <i class="el-icon-arrow-right"></i> </span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:"chooseOrg",
        data() {
            return {
                tableing:false,
                list:[]
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.getData()
        },
        methods:{
            getData(){
                let that = this
                that.tableing = true
                that.$axios.post('/paper/acg/orgList',{
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    that.tableing = false;
                    let v = res.data;
                    if (v.code == 0) {
                        that.list = v.data
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            clickRecord(){
                this.$router.push({
                    path: '/examRecords'
                })
            },
            comeList(id){
                this.$nextTick(()=>{
                    this.$router.push({
                        path: '/typeList',
                        query: {
                            id:id,
                        }
                    })
                })
            },
            logOut(){
                this.$router.push({
                    path: '/login',
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        position: relative;
        .record{
            position: absolute;
            right: 18%;
            top: 20px;
        }
        .exit{
            background-color: rgb(96,161,251);
            border: none;
            font-size: 13px;
            color: #fff;
            position: absolute;
            top: 20px;
            right: 10%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 60px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
    }
    .orgList{
        background-color: rgb(246, 246, 246);
        height: 60px;
        width: 80%;
        margin: 0 auto;
        display: block;
        margin-bottom: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); 
    }     
    .orgList:hover {
        background-color: #f4f0f0;
    }
    .orgList:active {
        background-color: rgba(46, 103, 222, 0.13);
        height: 59.5px;
        width: 79.9%;
    }    
    .orgList-imgBox{
        width: 40%;
        height: 100%;
        float: left;
        text-align: right;
        box-sizing: border-box;
        padding-right: 8px;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .orgList-img{
        max-width: 100%;
        max-height:100%;
    }
    .orgList-name{
        box-sizing: border-box;
        padding-left: 8px;
        width: 60%;
        height: 60px;
        line-height: 60px;
        float: right;
        text-align: left;
        display: inline-block;
        font-family: serif;
        color: #000;
        font-weight: bold;
        i{
            vertical-align: middle;
            margin-top:-3px;
        }
        i::before{
           margin-left: 10px;
           color: #000; 
           font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/chooseOrg/chooseOrg.vue